import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { RegisterSuccess } from '@app/core/user/store/actions';

/**
 * When user creates an account / When the sign up is validated.
 */
const events = getEvents((action: RegisterSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'account',
      accountAction: 'creation',
      accountType: action.payload.accountType ? action.payload.accountType : 'regular'
    }
  },
  {
    type: 'ESV Nvx Membres',
    container: TagContainer.Media
  }
]);

export default events;
